module.exports = __webpack_public_path__ + "img/co.d1a61f94.svg";